import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNewspaper2"><Path d="M1 4V20H9C9.867 20 10.4085 20.2352 10.7304 20.5445C11.0491 20.8507 11.25 21.323 11.25 22V7.75C11.25 5.67893 9.57107 4 7.5 4H1Z" fill="currentColor"/><Path d="M12.75 7.75V22C12.75 21.323 12.9509 20.8507 13.2696 20.5445C13.5915 20.2352 14.133 20 15 20H23V4H16.5C14.4289 4 12.75 5.67893 12.75 7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper2;
